import http from "./client"

export interface Board {
  id: string
  name: string
  description?: string
  config?: Record<string, any>
  is_owner?: boolean
}

export interface BoardWidget {
  id: string
  name: string
  widget_type: "table" | "chart" | "number" | "text"
  sql_query: string
  resource_id: string
  config: Record<string, any>
  position: number
}

export const listBoards = async (): Promise<Board[]> => {
  const res = await http.get<Board[]>(`/boards`)
  return res.data
}

export const getBoard = async (id: string): Promise<Board> => {
  const res = await http.get<Board>(`/boards/${id}`)
  return res.data
}

export const createBoard = async (data: { name: string; description?: string }): Promise<void> => {
  await http.post(`/boards`, data)
}

export const updateBoard = async (
  id: string,
  data: { name?: string; description?: string; config?: Record<string, any> }
): Promise<void> => {
  await http.put(`/boards/${id}`, data)
}

export const deleteBoard = async (id: string): Promise<void> => {
  await http.delete(`/boards/${id}`)
}

export const listBoardWidgets = async (boardId: string): Promise<BoardWidget[]> => {
  const res = await http.get<BoardWidget[]>(`/boards/${boardId}/widgets`)
  return res.data
}

export const createWidget = async (
  boardId: string,
  data: {
    name: string
    widget_type: "table" | "chart" | "number" | "text"
    sql_query: string
    resource_id: string
    config?: Record<string, any>
    position?: number
  }
): Promise<void> => {
  await http.post(`/boards/${boardId}/widgets`, data)
}

export const updateWidget = async (
  boardId: string,
  widgetId: string,
  data: {
    name?: string
    widget_type?: "table" | "chart" | "number" | "text"
    sql_query?: string
    resource_id?: string
    config?: Record<string, any>
    position?: number
  }
): Promise<void> => {
  await http.put(`/boards/${boardId}/widgets/${widgetId}`, data)
}

export const deleteWidget = async (boardId: string, widgetId: string): Promise<void> => {
  await http.delete(`/boards/${boardId}/widgets/${widgetId}`)
}

export const resyncWidget = async (boardId: string, widgetId: string): Promise<any> => {
  const res = await http.get(`/boards/${boardId}/widgets/${widgetId}/resync`)
  return res.data
}

// Board access (members + role grants)

export interface BoardAccessMember {
  account_id: string
  email: string
  first_name: string
  last_name: string
  created_at: string
}

export interface BoardAccessRoleGrant {
  role_id: string
  role_name: string
  created_at: string
}

export interface BoardAccessResponse {
  members: BoardAccessMember[]
  role_grants: BoardAccessRoleGrant[]
}

export const listBoardAccess = async (boardId: string): Promise<BoardAccessResponse> => {
  const res = await http.get<BoardAccessResponse>(`/boards/${boardId}/access`)
  return res.data
}

export type AddBoardAccessPayload = { account_id?: string; role_id?: string }
export type RemoveBoardAccessPayload = { account_id?: string; role_id?: string }

export const addBoardAccess = async (boardId: string, payload: AddBoardAccessPayload): Promise<void> => {
  await http.post(`/boards/${boardId}/access`, payload)
}

export const removeBoardAccess = async (boardId: string, payload: RemoveBoardAccessPayload): Promise<void> => {
  await http.delete(`/boards/${boardId}/access`, { data: payload })
}
